/*
 * BONSAI カスタム: Globo オプションのプルダウンに、リンク先商品の在庫状態を付ける（No.582）。全客向け。
 *
 * snippets/bonsai-addon-stock.liquid が埋めた window.BONSAI_ADDON_STOCK
 *   { 加算商品のvariantId: "preorder" | "soldout" }   ※在庫0以下のものだけ
 * を使って、
 *   preorder（在庫0・販売継続）→ 選択肢の末尾に「（お取り寄せ）」
 *   soldout （在庫0・販売停止）→ 選択肢の末尾に「（売り切れ）」＋ disabled（Globo は deny の在庫0を無言で失敗させる・No.567）
 * 本体商品の「予約注文（お取り寄せ）」「売り切れ」と同じ言い方に揃える。在庫ありには何も付けない。
 *
 * 業販向けの bonsai-b2b-addon-label.js も同じ option の文字列を書き換える。衝突しないよう、
 * こちらは option.dataset.bonsaiStock に接尾辞を置き、あちらは自分の文字列の末尾にそれを足す。
 *
 * もう一つ（No.539③・583）: Globo はオプション選択後に価格の数字だけを書き換えるため、
 * 隣の「（税抜 ¥…）」が本体価格のまま残る（例 ¥28,820 に対し 税抜 ¥23,000）。
 * 表示中の価格から税抜を計算し直して合わせる（税率は window.BONSAI_ADDON_TAX_RATE）。
 * 業者向けは bonsai-b2b-addon-label.js が自前の合計で税抜も直すので、そちらが動くときは触らない。
 */
(function () {
  var cfg = window.BONSAI_ADDON_STOCK;
  if (!cfg) return;
  var SUFFIX = { preorder: '（お取り寄せ）', soldout: '（売り切れ）' };
  var SUFFIX_RE = /（(お取り寄せ|売り切れ)）$/;
  var taxRate = window.BONSAI_ADDON_TAX_RATE || 10;

  function yen(n) { return '¥' + Math.round(n).toLocaleString('ja-JP'); }
  function parseYen(s) { var m = String(s).replace(/,/g, '').match(/¥\s*([0-9]+)/); return m ? parseFloat(m[1]) : NaN; }

  // 税抜併記を、表示中の価格（Globo が書き換えた後の数字）に合わせる
  function fixExTax() {
    if (window.BONSAI_B2B_ADDONS) return;   // 業者向け JS が自前の合計で直す
    document.querySelectorAll('[id^="price-"] .price__regular, [id^="price-"] .price__sale').forEach(function (box) {
      var ex = box.querySelector('.bonsai-price-ex-tax');
      if (!ex) return;
      var el = box.querySelector('.price-item--sale') || box.querySelector('span.price-item--regular');
      if (!el) return;
      var total = parseYen(el.textContent);
      if (isNaN(total)) return;
      var want = '（税抜 ' + yen(total / (1 + taxRate / 100)) + '）';
      if (ex.textContent !== want) ex.textContent = want;
    });
  }

  function apply() {
    fixExTax();
    document.querySelectorAll('option[gpo-data-variant-id]').forEach(function (opt) {
      var st = cfg[opt.getAttribute('gpo-data-variant-id')];
      if (!st || !SUFFIX[st]) return;
      var suffix = SUFFIX[st];
      opt.dataset.bonsaiStock = suffix;
      var text = opt.textContent.replace(SUFFIX_RE, '');
      if (opt.textContent !== text + suffix) opt.textContent = text + suffix;
      if (st === 'soldout' && !opt.disabled) opt.disabled = true;
    });
  }

  var timer = null;
  function schedule() {
    if (timer) return;
    timer = setTimeout(function () { timer = null; apply(); }, 60);
  }
  new MutationObserver(function () { schedule(); }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule); else schedule();
})();
